import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScStatsBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.014em;
  color: ${({ theme }) => theme.whiteColor};
  flex-wrap: wrap;
  padding: 12px 0;

  .desk-logo {
    display: block;
    position: absolute;
    right: 32px;
    top: 50%;
    transform: translateY(-50%);
    @media (${device.mobile}) {
      display: none;
    }
  }

  > span {
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: 2px 10px;

    &:not(:last-child) {
      border-right: 1px solid #ffd500;
    }
  }

  > span > span {
    margin-right: 4px;
    color: #ffd500;
  }

  @media (${device.mobile}) {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    > span {
      flex-shrink: 0;
    }
  }
`;
